const commonLabels = {
  key: 'commonLabels',
  name: 'Common Labels',

  petsafeTitleLabel: '{title} | PetSafe®',
};

exports.commonLabels = commonLabels;
